import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { roleDefaultRoutes, useAuthStore } from '@/stores/authStore';
import type { UserRole } from '@/types';
import { normalizeUserRole } from '@/utils/roleView';
import { canReadProcurement } from './procurementAccess';

type ProcurementProtectedRouteProps = {
  children: ReactNode;
};

/** FLOW[49426]: direct procurement URLs use the same fail-closed rule as page actions. */
export function ProcurementProtectedRoute({
  children,
}: ProcurementProtectedRouteProps) {
  const user = useAuthStore((state) => state.user);
  const rawRole = user?.roles?.[0] || user?.role;
  const role = normalizeUserRole(rawRole);
  const fallback = roleDefaultRoutes[role as UserRole] || '/v2/dashboard';

  return (
    <ProtectedRoute>
      {canReadProcurement(user) ? children : <Navigate to={fallback} replace />}
    </ProtectedRoute>
  );
}
